import axios from "axios";
import { doc, getDoc, getFirestore, onSnapshot, setDoc } from "firebase/firestore";
import {getFunctions,httpsCallable} from "firebase/functions";
import { useEffect, useState } from "react";
import { CloseButton, Table } from "react-bootstrap";
import { AiFillCodeSandboxCircle } from "react-icons/ai";
import { CgClose, CgCross, CgTapDouble } from "react-icons/cg";
import { FaPen } from "react-icons/fa";
import swal from "sweetalert";
import MessageRequestPromos from "./components/messageRequestPromos";
import VideoRequestPromos from "./components/videoRequestPromos";


export default function CelebPromos(props){

    const functions = getFunctions();
    const db=getFirestore();
    const [currentCelebDetails,setCurrentCelebDetails]= useState({});
    const [wallet,setWallet]=useState(0);
    var testingArray=[1,1,1,1,1,1,1,1,1,1,1];

    useEffect(async()=>{

        console.log("curent Id is"+props.id);

        const unsubscribe= onSnapshot(doc(db,"celebrities",props.id),(doc)=>{
            var data= doc.data();
            setCurrentCelebDetails(data);
            setWallet(data["wallet"]);
        })

        return function(){
            unsubscribe();
        }

    },[]);

    return (
        <div className="flex flex-row z-10 absolute backdrop-blur-sm w-full">
            <div className="w-1/4 bg-transparent relative"></div>

            <div className="p-10 w-3/4 bg-black/90 flex justify-start items-start relative flex-col overflow-scroll">


                <div className="self-end">
                    <button
                        onClick={()=>{
                            props.closeButton()
                        }}
                    >
                        <CgClose size={50}/>
                    </button>
                </div>

                <div style={{backgroundImage:`url('${currentCelebDetails===undefined?"":currentCelebDetails["imgSrc"]}')`}} className="mb-3 bg-black h-48 w-48 bg-cover bg-center rounded"/>

                <div className="mb-10 w-full text-white text-6xl font-bold">
                    {currentCelebDetails===undefined?"":currentCelebDetails["fullName"]}
                </div>


                <VideoRequestPromos celebId={props.id} currentCelebDetails={currentCelebDetails}/>
                <div className="mb-10 mt-10"/>
                <MessageRequestPromos celebId={props.id} currentCelebDetails={currentCelebDetails}/>

                


            </div>

        </div>
    )
    
}